import { Form } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAcceptInvitationMutation } from './useAuthMutations';
import { getCurrentUserDashboardRoute } from '@utils/routing';

export const useAcceptInvite = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const acceptMutation = useAcceptInvitationMutation();

    const token = searchParams.get('token') || '';
    const companyId = searchParams.get('company_id') || '';

    const onFinish = async (values) => {
        if (!token || !companyId) return;
        await acceptMutation.mutateAsync({
            token,
            company_id: companyId,
            name: values.name,
            newPassword: values.password,
        });
        const dashboardRoute = getCurrentUserDashboardRoute();
        navigate(dashboardRoute, { replace: true });
    };

    return {
        form,
        loading: acceptMutation.isPending,
        onFinish,
        token,
        companyId,
        hasValidParams: Boolean(token && companyId),
    };
};
